window.myShopifyFunctions = {
    data: {}, 
    storeData: function(key, value) {
        this.data[key] = value;
    },
    retrieveData: function(key) {
        return this.data[key];
    },
    
    resetIconSelection: function() {
        document.querySelectorAll('.icon-checkbox').forEach(checkbox => {
            checkbox.checked = false;
        });
    },
    
    enforceIconLimit: function() {
        const selectedVariant = this.retrieveData('selectedVariant');
        const selectedIcons = document.querySelectorAll('.icon-checkbox:checked').length;

        if (selectedIcons > selectedVariant) {
            alert(`Please select only ${selectedVariant} icons.`);
            
        }
    }
};
